import React from "react";

export function CompletionActions({
  currentStep,
  totalSteps,
  isLoading,
  loadingLabel,
  hideFinish,
  disableNext,
  onBack,
  onNext,
}) {
  const nextDisabled = isLoading || (disableNext === true);
  const buttonLabel = isLoading
    ? (loadingLabel || "Saving...")
    : currentStep === totalSteps
      ? "Finish"
      : "Next";
  return (
    <div className="business-completion-actions">
      <button
        type="button"
        disabled={currentStep === 1}
        className="btn-secondary"
        onClick={onBack}
      >
        Back
      </button>
      {hideFinish ? null : (
        <button
          type="button"
          className="btn-primary"
          onClick={onNext}
          disabled={nextDisabled}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
}
